export default {
	methods: {
		closeModal(mode) {
            this.isOpen = false;
            this.$emit("closed");
            if(typeof mode === 'object'){
                this.__resolve__scrolltop();
                this.$router.go(-1);
            }
		},
		openModal() {
            const fullPath = this.$route.fullPath;
            const query = fullPath.indexOf('?') === -1?'?mdl=1':'&mdl=1';
            this.__store__scrolltop();
            this.$router.push(`${fullPath}${query}`)
			this.isOpen = true;
        },
        __resolve__scrolltop(){//滚动到存储的scrollTop位置
            const modalBody = document.getElementById("modal_scroll_container");
			document.querySelector("html").classList.remove("noscroll");
			window.scrollTo(0, sessionStorage.scrollY || 0);
			modalBody && (modalBody.scrollTop = 0);
        },
        __store__scrolltop(){//存储当前scrollTop
            const scrollY = window.scrollY === undefined ? window.pageYOffset : window.scrollY;
            sessionStorage.scrollY = scrollY;
            //让整个页面禁止滚动，防止在弹出弹窗时弹窗滚动后面也滚动
            document.querySelector("html").classList.add("noscroll");
        }
	},
	data() {
		return {
			isOpen: false
		};
    },
    watch: {
        $route(to,from) {
            if(to.query.mdl){
                document.title = from.meta.title;
            }else{
                if(this.isOpen){
                    this.closeModal('using_back_button');
                }
            }
        }
    },
};
